import React, { createContext, useContext } from 'react';
import { useSearchParamsSelector } from '../../../shared/packages/searchParamsManager';
import { searchParamKeys } from '../../../shared/configs/searchParams';
import { parseAcceptanceSlug } from '../../../shared/packages/acceptance';
import { useAcceptanceListInfo } from './listInfo';

const Context = createContext();

export const CurrentAcceptanceProvider = ({ children }) => {
  const { data } = useAcceptanceListInfo({
    dataType: useAcceptanceListInfo.dataTypes.map,
  });

  const acceptanceId = useSearchParamsSelector((state) => {
    const { acceptanceId } = parseAcceptanceSlug(
      state[searchParamKeys.acceptance]
    );
    return acceptanceId;
  });

  return (
    <Context.Provider value={data.get(acceptanceId)}>
      {children}
    </Context.Provider>
  );
};

export const useCurrentAcceptance = () => useContext(Context);
